$(function () {
    // Forzar selección si el sello es 'dispe'
    if (typeof empresaSello !== 'undefined' && empresaSello === 'dispe') {
        // Forzar precios a 3
        if (Cookies.get('showPrecios') !== btoa('3')) {
            Cookies.set('showPrecios', btoa('3'), {expires: 365});
        }
        // Forzar descuentos activados
        if (Cookies.get('showDtos') !== btoa('1')) {
            Cookies.set('showDtos', btoa('1'), {expires: 365});
        }
    }
    inicializarPreciosYDtos();

    // if (typeof authUser !== 'undefined' && authUser.rol_id === 3) {
    if ($('#noticesBtn').length) {
        loadAvisos();
    }
});

/**
 * Hide/Show discounts on all web app
 */
window.toggleDtos = function (newValue) {
    newValue = newValue ? 1 : 0

    Cookies.set('showDtos', btoa(newValue), {expires: 365});

    if (newValue) {
        $('.product-discount').show();
    } else {
        $('.product-discount').hide();
    }
}

/**
 * Init discounts on all web app
 */
window.inicializarDtos = function () {
    let showDtos = '1';
    if (typeof empresaSello !== 'undefined' && empresaSello === 'dispe') {
        showDtos = '1';
    } else if (Cookies.get('showDtos') !== undefined) {
        showDtos = atob(Cookies.get('showDtos'));
    }
    if (showDtos === '1') {
        $('.product-discount').show();
        $('#s2').attr('checked', true);
    } else {
        $('.product-discount').hide();
        $('#s2').attr('checked', false);
    }
}

/**
 * Change prices on all web app
 */
window.togglePrecios = function (newValue) {
    Cookies.set('showPrecios', btoa(newValue), {expires: 365});
    $('.product-price-info-event').hide();
    $('.product-price-selector').removeClass('active');
    $(`#product-price-selector-${newValue}`).addClass('active');
    if (newValue) {
        if (newValue === 1) { // El 1 activa todos
            $(`.product-price-info-2, .product-price-info-3`).show();
        } else {
            $(`.product-price-info-${newValue}`).show();
        }
    } // El 0 no activa ninguno (Oculta todos)
}

/**
 * Init prices on all web app
 */
window.inicializarPrecios = function () {
    let price = 1;
    if (typeof empresaSello !== 'undefined' && (
        empresaSello === 'dispe' ||
        (
            typeof isImpersonating !== 'undefined' &&
            (
                impersonator.rol_id === 4 ||
                impersonator.rol_id === 5
            ) &&
            impersonatorAgrupaciones.includes('mhe')
        )
    )) {

        price = 3;
    } else if (Cookies.get('showPrecios') !== undefined) {
        price = atob(Cookies.get('showPrecios'));
    }
    $('.product-price-info-event').hide();
    $('.product-price-selector').removeClass('active');
    $(`#product-price-selector-${price}`).addClass('active');
    if (price) {
        if (parseInt(price) === 1) { // El 1 activa todos
            $(`.product-price-info-2, .product-price-info-3`).show();
        } else {
            $(`.product-price-info-${price}`).show();
        }
    } // El 0 no activa ninguno (Oculta todos)
}

/**
 * Init prices and discounts on all web app
 */
window.inicializarPreciosYDtos = function () {
    inicializarPrecios();
    inicializarDtos();
}

/*** AVISOS ***/

/**
 * Loads notices
 */
window.loadAvisos = function () {
    $.ajax({
        url:      urlAviso + '/get',
        type:     'POST',
        dataType: 'json',
        data:     {},
    })
     .done(function (response) {
         fillAvisos(response.list);
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     });
}

/**
 * Fills notices
 *
 * @param avisos
 */
window.fillAvisos = function (avisos) {
    let listadoAvisosLeidos = JSON.parse(localStorage.getItem('listadoAvisosLeidos') || '[]');
    let numAvisosSinLeer    = 0;
    let numAvisosLeidos     = 0;

    avisos.forEach((aviso, index) => {
        if (listadoAvisosLeidos.includes(aviso.id)) {
            appendAviso(aviso, true);
            numAvisosLeidos++;
        } else {
            appendAviso(aviso, false);
            numAvisosSinLeer++;
        }
    });

    if (numAvisosLeidos === 0) {
        $('#seeReadNoticesBtn').closest('li').addClass('d-none');
        $('#readNoticesContainer').addClass('d-none');
    } else {
        toggleAvisosLeidos();
    }

    if (numAvisosSinLeer !== 0) {
        $('#totalAvisosSinLeer').text(numAvisosSinLeer).removeClass('d-none');
    } else {
        $('#noUnreadNoticesMessage').removeClass('d-none');
    }

    $('#noticesBtn').removeClass('d-none');

    const currentAvisoIds = new Set(avisos.map(aviso => aviso.id));

    const filteredAvisosLeidos = [...listadoAvisosLeidos].filter(aviso => currentAvisoIds.has(aviso));

    localStorage.setItem('listadoAvisosLeidos', JSON.stringify(filteredAvisosLeidos));
}

/**
 * Appends notice
 *
 * @param aviso
 * @param isRead
 */
window.appendAviso = function (aviso, isRead) {
    let icono = '';

    switch (aviso.tipo) {
        case 1:
            icono = '<i class="notice-icon ri-information-fill info"></i>';
            break;
        case 2:
            icono = '<i class="notice-icon ri-checkbox-circle-fill success"></i>';
            break;
        case 3:
            icono = '<i class="notice-icon ri-error-warning-fill warning"></i>';
            break;
        case 4:
            icono = '<i class="notice-icon ri-error-warning-fill danger"></i>';
            break;
    }

    if (isRead) {
        $('#readNoticesContainer ul').append(
            `<li class="notice notice-read" id="aviso-${aviso.id}">
                ${icono}
                <div>
                    ${aviso.descripcion[locale]}
                </div>
            </li>`
        );
    } else {
        let $aviso = $(`<li class="notice notice-unread" id="aviso-${aviso.id}">
                            ${icono}
                            <div>
                                ${aviso.descripcion[locale]}
                            </div>
                            <button
                                class="notice-unread-btn"
                                onclick="setAvisoAsRead(this)">
                                <i class="ri-close-line notice-unread-btn-icon"></i>
                            </button>
                        </li>`);

        $aviso.find('button').data('aviso_id', aviso.id);
        $aviso.find('button').data('aviso_tipo', aviso.tipo);
        $aviso.find('button').data('aviso_descripcion', aviso.descripcion);

        $('#noticesMenuTitle').after($aviso);
    }
}

/**
 * Toggles read notices
 */
window.toggleAvisosLeidos = function () {
    let readNoticesContainer = $('#readNoticesContainer');
    let seeReadNoticesBtn    = $('#seeReadNoticesBtn');
    if (readNoticesContainer.hasClass('show')) {
        readNoticesContainer.slideUp();
        readNoticesContainer.removeClass('show');
        seeReadNoticesBtn.text(transMostrarAvisosLeidos);
    } else {
        readNoticesContainer.slideDown();
        readNoticesContainer.addClass('show');
        seeReadNoticesBtn.text(transOcultarAvisosLeidos);
    }
}

/**
 * Sets notice as read
 *
 * @param obj
 */
window.setAvisoAsRead = function (obj) {
    const aviso = {
        id:          $(obj).data('aviso_id'),
        tipo:        $(obj).data('aviso_tipo'),
        descripcion: $(obj).data('aviso_descripcion')
    };

    let listadoAvisosLeidos = JSON.parse(localStorage.getItem('listadoAvisosLeidos'));
    listadoAvisosLeidos.push(aviso.id);

    if ($('#readNoticesContainer').hasClass('d-none')) {
        $('#seeReadNoticesBtn').closest('li').removeClass('d-none');
        $('#readNoticesContainer').removeClass('d-none');
    }

    let totalAvisosSinLeer = parseInt($('#totalAvisosSinLeer').text());
    if (totalAvisosSinLeer === 1) {
        $('#noUnreadNoticesMessage').removeClass('d-none');
        $('#totalAvisosSinLeer').addClass('d-none');
    } else {
        $('#totalAvisosSinLeer').text(totalAvisosSinLeer - 1);
    }

    $(`#aviso-${aviso.id}`).slideUp('slow', function () {
        $(this).remove();
    });

    toggleAvisosLeidos();

    appendAviso(aviso, true);

    localStorage.setItem('listadoAvisosLeidos', JSON.stringify(listadoAvisosLeidos));
}

// Evitar que el submenú cierre el menú principal al hacer clic
document.querySelectorAll('.dropdown-submenu .dropdown-toggle').forEach(function (element) {
    element.addEventListener('click', function (e) {
        if (this.nextElementSibling) {
            e.preventDefault();
            e.stopPropagation(); // Evitar que el evento cierre el menú padre
            this.nextElementSibling.classList.toggle('show'); // Mostrar u ocultar el submenú
        }
    });
});

// Cerrar submenú si se hace clic fuera de él
document.addEventListener('click', function (e) {
    if (!e.target.closest('.dropdown-submenu')) {
        document.querySelectorAll('.dropdown-submenu .dropdown-menu').forEach(function (submenu) {
            submenu.classList.remove('show');
        });
    }
});
